export default "__VITE_ASSET__QC2r5y0j__"